import { render, staticRenderFns } from "./SingleAutoMatching.vue?vue&type=template&id=5fd68612&"
import script from "./SingleAutoMatching.vue?vue&type=script&lang=js&"
export * from "./SingleAutoMatching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports